import { render, staticRenderFns } from "./educator-column.vue?vue&type=template&id=3aa6f839&scoped=true&"
import script from "./educator-column.vue?vue&type=script&lang=js&"
export * from "./educator-column.vue?vue&type=script&lang=js&"
import style0 from "./educator-column.vue?vue&type=style&index=0&id=3aa6f839&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6f839",
  null
  
)

export default component.exports